const route = [
    {
        path: '/hnPaper/chapter/:sid/:id',
        component: function (resolve) {
            require(['VIEWS/activity/xcpTea/selectChapter.vue'], resolve);
        }
    }, {
        path: '/hnPaper/list',
        component: function (resolve) {
            require(['VIEWS/activity/xcpTea/hnPaper.vue'], resolve);
        }
    },
]
export default route